export default "__VITE_ASSET__79a8352a__"